import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import type { StreamDefinition } from '../../signalr/types'
import { marketClosed } from './actions'

export const marketClosedDefinition: StreamDefinition<[], boolean, Action> = {
  method: 'MarketClosed',
  strategy: 'switch',
  getParams,
  mapResponse: marketClosed,
  cancelOn: []
}
